import { gql } from '@apollo/client';

export const GET_SUPPLIERS = gql`
  query GetSuppliers($projectId: ID!) {
    suppliers(projectId: $projectId) {
      id
      projectId
      ownerCompanyId
      counterpartyCompanyId
      name
      domain
      direction
      status
      categories
      notes
      createdAt
      updatedAt
      ownerCompany {
        id
        name
      }
      counterpartyCompany {
        id
        name
        isSupplierShell
      }
      invite {
        id
        email
        firstName
        lastName
        language
        status
        lastSentAt
        acceptedAt
        cancelledAt
      }
      managedFacilities {
        id
        relationshipId
        name
        city
        country
        type
        notes
        createdAt
        updatedAt
      }
      sharedFacilities {
        id
        relationshipId
        facilityId
        sharedAt
        facility {
          id
          name
          city
          country
          type
        }
        sharedBy {
          id
          email
          firstName
          lastName
        }
      }
      ownSharedFacilities {
        id
        relationshipId
        facilityId
        sharedAt
        facility {
          id
          name
          city
          country
          type
        }
        sharedBy {
          id
          email
          firstName
          lastName
        }
      }
    }
  }
`;

export const GET_SUPPLIER = gql`
  query GetSupplier($id: ID!, $projectId: ID!) {
    supplier(id: $id, projectId: $projectId) {
      id
      projectId
      ownerCompanyId
      counterpartyCompanyId
      name
      domain
      direction
      status
      categories
      notes
      createdAt
      updatedAt
      ownerCompany {
        id
        name
      }
      counterpartyCompany {
        id
        name
        isSupplierShell
      }
      invite {
        id
        email
        firstName
        lastName
        language
        status
        lastSentAt
        acceptedAt
        cancelledAt
      }
      managedFacilities {
        id
        relationshipId
        name
        city
        country
        type
        notes
        createdAt
        updatedAt
      }
      sharedFacilities {
        id
        relationshipId
        facilityId
        sharedAt
        facility {
          id
          name
          city
          country
          type
        }
        sharedBy {
          id
          email
          firstName
          lastName
        }
      }
      ownSharedFacilities {
        id
        relationshipId
        facilityId
        sharedAt
        facility {
          id
          name
          city
          country
          type
        }
        sharedBy {
          id
          email
          firstName
          lastName
        }
      }
    }
  }
`;

export const GET_INCOMING_SUPPLIER_CONNECTION_REQUESTS = gql`
  query GetIncomingSupplierConnectionRequests {
    incomingSupplierConnectionRequests {
      id
      projectId
      ownerCompanyId
      counterpartyCompanyId
      name
      domain
      direction
      status
      categories
      createdAt
      updatedAt
      ownerCompany {
        id
        name
      }
      counterpartyCompany {
        id
        name
        isSupplierShell
      }
      updatedBy {
        id
        email
        firstName
        lastName
      }
    }
  }
`;

export const GET_SUPPLIER_COMPANY_MATCH = gql`
  query GetSupplierCompanyMatch($domain: String!) {
    supplierCompanyMatch(domain: $domain) {
      id
      name
      domain
      headquarter
      isSupplierShell
    }
  }
`;

export const GET_SUPPLIER_CONNECTION_REQUEST = gql`
  query GetSupplierConnectionRequest($id: ID!) {
    supplierConnectionRequest(id: $id) {
      id
      projectId
      ownerCompanyId
      counterpartyCompanyId
      name
      domain
      direction
      status
      categories
      createdAt
      updatedAt
      ownerCompany {
        id
        name
      }
      counterpartyCompany {
        id
        name
        defaultProjectId
        isSupplierShell
      }
      updatedBy {
        id
        email
        firstName
        lastName
      }
      sharedFacilities {
        id
        facilityId
        facility {
          id
          name
          city
          country
          type
        }
      }
    }
  }
`;
